<template>
  <!-- eslint-disable max-len -->
  <div>
    <v-data-table
      width="100%"
      height="70vh"
      :sort-by.sync="pagination.sortBy"
      :sort-desc.sync="pagination.descending"
      fixed-header
      :items-per-page="15"
      :loading="loading"
      :headers="headers"
      :search="search"
      :items="orders"
      class="table elevation-0"
    >
      <template v-slot:header="{ header }">
        <tr class="table__header-row">
          <th
            v-for="h in header"
            :key="h.text"
            :class="[
              'table__header',
              h.text,
              h.text !== 'ACTIONS' ? 'column_sortable' : '',
              pagination.descending ? 'desc' : 'asc',
              h.value === pagination.sortBy ? 'active' : '',
            ]"
            @click="h.text !== 'ACTIONS' ? changeSort(h.value) : () => {}"
          >
            {{ h.text }}
            <v-icon v-if="!pagination.descending && h.value === pagination.sortBy" class="table__header-icon" small
              >arrow_upward</v-icon
            >
            <v-icon v-if="pagination.descending && h.value === pagination.sortBy" class="table__header-icon" small
              >arrow_downward</v-icon
            >
          </th>
        </tr>
      </template>
      <template v-slot:item="{ item }">
        <tr :class="{ table__row: true, 'process-error': item.error }" :key="item.uuid">
          <td :class="{ 'table__cell full': true, 'process-error-border': item.error }" id="full">
            <button
              v-if="!item.partial"
              @click="toggleFull(item)"
              class="checkbox-btn"
              :id="'full-' + item.uuid"
              :style="'display:' + (!item.partial ? 'block' : 'none')"
            >
              <div class="full-icon"></div>
            </button>
            <button
              v-if="item.partial"
              @click="toggleFull(item)"
              class="checkbox-btn"
              :id="'notFull-' + item.uuid"
              :style="'display:' + (item.partial ? 'block' : 'none')"
            >
              <div class="partial-icon"></div>
            </button>
          </td>
          <td class="table__cell timeStamp">{{ item.formattedDate }}</td>
          <td class="table__cell email">{{ item.email }}</td>
          <td class="table__cell subject">{{ item.subject }}</td>
          <td class="table__cell is-duplicate">
            <div class="l-is-duplicate">
                <div
                  v-if="item.isDuplicateOf"
                  class="urgent-icon"
                ></div>
            </div>
          </td>
          <!-- <td class="table__cell urgent"> -->
          <!--   <div> -->
          <!--     <button -->
          <!--       @click="toggleUrgent(item, 'urgent')" -->
          <!--       class="checkbox-btn" -->
          <!--       :id="'orderUrgent-' + item.uuid" -->
          <!--       :style="'display:' + (item.urgent ? 'block' : 'none')" -->
          <!--     > -->
          <!--       <div class="urgent-icon"></div> -->
          <!--     </button> -->
          <!--     <button -->
          <!--       @click="toggleUrgent(item, 'notUrgent')" -->
          <!--       class="checkbox-btn" -->
          <!--       :id="'orderNotUrgent-' + item.uuid" -->
          <!--       :style="'display:' + (!item.urgent ? 'block' : 'none')" -->
          <!--     > -->
          <!--       <div class="not-urgent-icon"></div> -->
          <!--     </button> -->
          <!--   </div> -->
          <!-- </td> -->
          <td class="table__cell ready">
            <div>
              <button
                @click="toggleReady(item, 'ready')"
                class="checkbox-btn ready-checked"
                :id="'ready-' + item.uuid"
                :style="'display:' + (item.ready ? 'block' : 'none')"
              >
                <div class="ready-icon"></div>
              </button>
              <button
                @click="toggleReady(item, 'notReady')"
                class="checkbox-btn ready-unchecked"
                :id="'notReady-' + item.uuid"
                :style="'display:' + (!item.ready ? 'block' : 'none')"
              >
                <div class="not-ready-icon"></div>
              </button>
            </div>
          </td>
          <td class="table__cell">{{ item.fileName }}</td>
          <td class="table__cell actions">
            <button
              v-if="!item.error && !item.processing"
              class="download-btn"
              :class="{ 'download-btn': true, inverted: item.isDownloaded }"
              @click="downloadDocument(item)"
            >
              DOWNLOAD
            </button>
            <button
              :key="'error-icon-container-' + item.uuid"
              v-if="item.error && !item.processing"
              class="checkbox-btn"
              @click="openUploadModal(item)"
            >
              <div class="error-icon"></div>
            </button>
            <div v-if="item.error && item.processing" class="loader-container">
              <div class="loading-icon"></div>
            </div>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        <div v-if="loading">
          <span>Loading data, please wait...</span>
        </div>
        <div v-else>
          <span>No records available for this view</span>
        </div>
      </template>
    </v-data-table>
    <FileUploadModal
      v-if="isOpen"
      :currentFile="currentFile"
      v-on:startUpload="startProgress"
      v-on:completed="stopProgress"
      v-on:percentage="updatePercentage"
      v-on:close="closeUploadModal"
    />
  </div>
</template>

<script>
import FileUploadModal from './FileUploadModal';
import API from '../services/API';

export default {
  name: 'Orders-Table',
  props: ['search', 'orders', 'loading'],
  components: {
    FileUploadModal,
  },
  data() {
    return {
      pagination: { sortBy: 'date', descending: true },
      isOpen: false,
      percentage: null,
      currentFile: null,
      headers: [
        {
          text: 'FULL/PARTIAL',
          align: 'left',
          value: 'partial',
          width: 100,
        },
        {
          text: 'TIMESTAMP',
          value: 'date',
          width: 220,
        },
        { text: 'EMAIL ADDRESS', value: 'email', width: 350 },
        { text: 'SUBJECT LINE', value: 'subject', width: 400 },
        { text: 'DUPLICATE', value: 'duplicate', width: 50 },
        { text: 'READY', value: 'ready', width: 50 },
        { text: 'FILE NAME', value: 'fileName', width: 350 },
        { text: 'ACTIONS', value: 'attachmentId', width: 100 },
      ],
    };
  },
  methods: {
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    downloadDocument(item) {
      item.isDownloaded = true;

      API.get(`documents/excel/${item.attachmentId}`).then((res) => {
        window.open(res.data.url, '_blank');
      });
    },
    toggleUrgent(item, iconType) {
      item.urgent = !item.urgent;

      API.put(`/documents/${item.uuid}`, {
        urgent: item.urgent,
      });
      const urgentElement = document.getElementById('orderUrgent-' + item.uuid);
      const notUrgentElement = document.getElementById('orderNotUrgent-' + item.uuid);

      if (iconType === 'notUrgent') {
        urgentElement.style.display = 'block';
        notUrgentElement.style.display = 'none';
      } else {
        urgentElement.style.display = 'none';
        notUrgentElement.style.display = 'block';
      }
    },
    toggleReady(item, iconType) {
      item.ready = !item.ready;

      API.put(`/documents/${item.uuid}`, {
        ready: item.ready,
      });
      const readyElement = document.getElementById('ready-' + item.uuid);
      const notReadyElement = document.getElementById('notReady-' + item.uuid);

      if (iconType === 'notReady') {
        readyElement.style.display = 'block';
        notReadyElement.style.display = 'none';
      } else {
        readyElement.style.display = 'none';
        notReadyElement.style.display = 'block';
      }
    },
    toggleFull(item) {
      item.partial = !item.partial;
      API.put(`/documents/${item.uuid}`, {
        partial: item.partial,
      }).catch((e) => {
        console.error(e);
        item.partial = !item.partial;
      });
    },
    openUploadModal(file) {
      this.currentFile = file;
      this.isOpen = true;
    },
    closeUploadModal() {
      this.isOpen = false;
    },
    startProgress() {
      this.percentage = 0;
    },
    stopProgress() {
      this.percentage = null;
      this.currentFile = null;
    },
    updatePercentage(percent) {
      this.percentage = percent;
    },
  },
};
</script>

<style lang="scss" scoped>
tbody tr:nth-of-type(odd) {
  background-color: #f6f6f6;

  &:hover {
    background-color: #f6f6f6 !important;
  }
}

tbody tr:nth-of-type(even) {
  &:hover {
    background-color: #fff !important;
  }
}

.checkbox-btn {
  background: transparent;
  outline: none;
}

.table {
  width: 100%;
  min-width: 900px;
  overflow-x: auto;
  overflow-y: auto;
  table-layout: fixed;

  .column_sortable {
    cursor: pointer;
  }

  &__header-row {
    border-bottom: 2px solid #a9a9a9 !important;
  }

  &__header {
    height: 2.1rem;
    color: #212121 !important;
    font-family: Heebo;
    font-size: 1.4rem !important;
    font-weight: bold;
    letter-spacing: 0.124rem;
    line-height: 2.1rem;
    text-align: left;

    &-icon {
      transform: translateY(-4px);
    }
  }

  &__row {
    height: 5.2rem !important;
  }

  &__cell {
    padding: 0 1rem;
    color: #212121;
    font-family: Heebo;
    font-size: 1.4rem;
    line-height: 2.1rem;
  }

  .full {
    width: 11rem;
    min-height: 5.2rem;
    padding-left: 20px !important;
  }

  .urgent button {
    margin-left: 15px;
  }

  .email {
    margin-left: 5px;
  }

  .ready {
    &-checked,
    &-unchecked {
      margin-left: 15px;
    }
  }

  .actions {
    width: 12rem;
    padding: 0 0 0 0.5rem !important;

    & > * {
      display: block;
      width: 50%;
      text-align: center;
      float: left;
    }
  }

  td:not(.process-error-border) {
    border-left: 8px solid transparent;
  }

  .process-error {
    background-color: #f6e6e6;

    &:hover {
      background-color: #f6e6e6 !important;
    }

    &-border {
      border-left: 15px solid #cb201f;
    }
  }
}

.download {
  text-decoration: none;
}

.download-btn {
  border: 1.5px solid #999;
  border-radius: 15px;
  background-color: #fff;
  font-size: 10px;
  font-weight: bold;
  width: 72px !important;
  height: 23px;
  text-align: center;

  &.inverted {
    background-color: gray;
    color: white;
  }
}

.loader-container {
  width: 50px !important;
  height: 5px;
  margin-left: 0.75rem;
}

.error-icon {
  background: url('../assets/img/error.svg');
  background-size: 100% 100%;
  width: 72px;
  height: 23px;
}

.full-icon {
  background: url('../assets/img/full.svg');
  background-size: 100% 100%;
  width: 59px;
  height: 23px;
}

.partial-icon {
  background: url('../assets/img/partial.svg');
  background-size: 100% 100%;
  width: 59px;
  height: 23px;
}

.not-urgent-icon {
  background: url('../assets/img/not-urgent.svg');
  background-size: 100% 100%;
  width: 20px;
  height: 20px;
}

.urgent-icon {
  background: url('../assets/img/urgent.svg');
  background-size: 100% 100%;
  width: 20px;
  height: 20px;
}

.ready-icon {
  background: url('../assets/img/toggle-on.svg');
  background-size: 100% 100%;
  width: 20px;
  height: 20px;
}

.not-ready-icon {
  background: url('../assets/img/toggle-off.svg');
  background-size: 100% 100%;
  width: 20px;
  height: 20px;
}

.loading-icon {
  background: url('../assets/img/linear-loading.svg');
  background-size: 100% 100%;
  width: 40px;
  height: 8px;
  margin: auto;
}
.l-is-duplicate {
  display: flex;
  justify-content: center;
}
</style>
